// ─── TEXT PROCESSING UTILITIES ───────────────────────────────────────────────
// Pure functions — no state, no React, no side effects.
//   isValidUrl(url)    → true only for an absolute http(s) URL
//   normalizeUrl(url)  → the trimmed URL with https:// prepended when it has no
//                        scheme; '' for anything that is not a non-blank string
// No HTML sanitiser lives here: the history card never renders HTML strings
// (outputs/pieces/BlocksView.jsx builds elements from the block model) and the
// clipboard / file HTML comes from publish/serialize.

// ─── URL Validator ───────────────────────────────────────────────────────────

export function isValidUrl(url) {
  if (!url) return false;
  try {
    new URL(url);
    return url.startsWith('http://') || url.startsWith('https://');
  } catch (_e) {
    return false;
  }
}

// ─── URL Normalizer ─────────────────────────────────────────────────────────

export function normalizeUrl(url) {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (!trimmed) return '';
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return 'https://' + trimmed;
}
